import { BulletListItem, IconPosition } from 'embed/components/BulletList'
import * as React from 'react'
import { CalculatorIcon, CheckIcon, QuestionIcon, StopwatchIcon, TransferIcon } from '../icons'

export const howYouSpend = (
  <BulletListItem
    icon={<TransferIcon />}
    iconPosition={IconPosition.TOP}
    header="Tell us how you spend"
    content="You’re unique, so these credit card offers are personalized"
  />
)

export const numberCrunch = (
  <BulletListItem
    icon={<CalculatorIcon />}
    iconPosition={IconPosition.TOP}
    header="We crunch the numbers"
    content="See the rewards you could be earning calculated using your spending habits"
  />
)

export const getRec = (
  <BulletListItem
    icon={<CheckIcon />}
    iconPosition={IconPosition.TOP}
    header="Get recommendations"
    content="Get matched with personalized offers in one quick and easy place"
  />
)

export const answerQuestions = (
  <BulletListItem
    icon={<QuestionIcon />}
    iconPosition={IconPosition.TOP}
    header="Answer a few questions"
    content="Fill out our simple form and we’ll match you with credit cards from top issuers"
  />
)

export const getMatched = (
  <BulletListItem
    icon={<CheckIcon />}
    iconPosition={IconPosition.TOP}
    header="Get Matched"
    content="Find the best card for your lifestyle and credit profile quickly and easily"
  />
)
export const noImpact = (
  <BulletListItem
    icon={<CheckIcon />}
    iconPosition={IconPosition.TOP}
    header="No impact to your credit"
    content="Compare personalized card offers without hurting your credit score"
  />
)

export const quickEasy = (
  <BulletListItem
    icon={<StopwatchIcon />}
    iconPosition={IconPosition.TOP}
    header="Quick and easy"
    content="Get matched with offers that are personalized to your needs in less than 60 seconds"
  />
)
